<div class="container" [class.ltr]="layoutDirectionLtr()" [class.rtl]="!layoutDirectionLtr()" [class.boxed]="word.needsGloss(frequencyThreshold)" [ngClass]="word.language">
    <div class="baseline"  [ngClass]="word.language" (dblclick)="showParsing()">{{word.text}}</div>
    @if(word) {
        <div class="gloss-container">
            @for( element of word.elements; track element.word_id) {
                @if( element.frequency < frequencyThreshold ) {
                    <app-gloss-selector [element]="element" [verse]="verse"></app-gloss-selector>
                }
            }
        </div>
    }
</div>